import { formatINR } from "@/hooks/useCountdown";

type Props = {
  price: number;
  compareAt?: number | null;
  days?: number | null;
  size?: "sm" | "md" | "lg";
  className?: string;
};

/**
 * Canonical TruWe price presentation.
 * Renders: ₹1,399  ₹1,699  ·  Save ₹300  ·  ₹47/day
 */
export function PriceBlock({ price, compareAt = null, days = null, size = "md", className = "" }: Props) {
  const hasDiscount = compareAt !== null && compareAt > price;
  const save = hasDiscount ? Math.round((compareAt as number) - price) : 0;
  const perDay = days && days > 0 ? Math.round(price / days) : null;

  const sizes = {
    sm: { price: "text-base", meta: "text-[11px]" },
    md: { price: "text-xl", meta: "text-xs" },
    lg: { price: "text-2xl md:text-3xl", meta: "text-sm" },
  }[size];

  return (
    <div className={`flex flex-wrap items-baseline gap-x-2 gap-y-1 ${className}`}>
      <span
        className={`font-display font-semibold text-brand-deep tabular-nums ${sizes.price}`}
        style={{ fontVariantNumeric: "tabular-nums" }}
      >
        ₹{formatINR(price)}
      </span>
      {hasDiscount && (
        <span
          className={`font-normal text-muted-foreground line-through tabular-nums ${sizes.meta}`}
          style={{ fontVariantNumeric: "tabular-nums" }}
        >
          ₹{formatINR(compareAt as number)}
        </span>
      )}
      <span className={`text-muted-foreground ${sizes.meta}`}>
        {hasDiscount && <span className="font-semibold text-brand">· Save ₹{save} </span>}
        {perDay !== null && <span>· ₹{perDay}/day</span>}
      </span>
    </div>
  );
}
